// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"styles_homeContent__jxl6Y","homeContentCTA":"styles_homeContentCTA__AoH_8","homePartner":"styles_homePartner__1vFls"};